import React, { Component } from "react";

export default class Failed extends Component {

    componentDidMount() {
        // Auto redirect after 3 seconds
        this.timer = setTimeout(() => {
            // Hard redirect clears SPA history
            window.location.replace("/");
        }, 3000);
    }

    componentWillUnmount() {
        clearTimeout(this.timer);
    }

    render() {
        return (
            <div className="card checkout-step-one">
                <section className="breadcrumb-bg mt-5">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-sm-12 text-center">
                                <div className="page-title order-done">
                                    <i
                                        className="mdi mdi-close-circle-outline text-secondary"
                                        style={{ fontSize: "14rem" }}
                                    />
                                    <h1>Transaction Failed</h1>
                                    <p className="col-sm-6 mx-auto mt-3 mb-5">
                                        Oops! Your payment has been declined. Please try again later
                                    </p>
                                    <p className="text-muted">
                                        Redirecting to home in 3 seconds...
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}
